import React, { useRef, useState, useEffect } from "react";
import useOutSideAlerter from "../hooks/useOutsideAlerter";
import AddFolderMutation from "../mutations/AddFolderMutation";
import environment from "../Environment";
import { commitLocalUpdate } from "react-relay";
import "./Modal.css";
import { useNavigate } from "react-router-dom";
// import { useNavigate } from "react-router-dom";
import RichTextEditor from "./RichTextEditor";
import { updateLocalSetting } from "../Environment";
import { useTheme } from "../contexts/ThemeContext";
import AddFeedBox from "../AddFeedBox";
import {
    EmailShareButton,
    FacebookShareButton,
    HatenaShareButton,
    InstapaperShareButton,
    LineShareButton,
    LinkedinShareButton,
    LivejournalShareButton,
    MailruShareButton,
    OKShareButton,
    PinterestShareButton,
    PocketShareButton,
    RedditShareButton,
    TelegramShareButton,
    TumblrShareButton,
    TwitterShareButton,
    ViberShareButton,
    VKShareButton,
    WhatsappShareButton,
    WorkplaceShareButton,
} from "react-share";

import {
    EmailIcon,
    FacebookIcon,
    FacebookMessengerIcon,
    HatenaIcon,
    InstapaperIcon,
    LineIcon,
    LinkedinIcon,
    LivejournalIcon,
    MailruIcon,
    OKIcon,
    PinterestIcon,
    PocketIcon,
    RedditIcon,
    TelegramIcon,
    TumblrIcon,
    TwitterIcon,
    ViberIcon,
    VKIcon,
    WeiboIcon,
    WhatsappIcon,
    WorkplaceIcon,
} from "react-share";

export function Modal(props) {
    let [isActivated] = useState(props.isModalActive);
    const wrapperRef = useRef(null);
    let isOutside = useOutSideAlerter(wrapperRef);
    const theme = useTheme();
    function onCloseClick(e) {
        e.preventDefault();
        props.setIsModalActive(false);
    }

    let isOpen = isActivated ? "open" : "close";

    useEffect(() => {
        if (isOutside) {
            props.setIsModalActive(false);
        }
    }, [isOutside]);

    return (
        <div className={`modal-container modal-container-${isOpen}`}>
            <div
                style={props.style.modal}
                ref={wrapperRef}
                className={`modal theme-${theme.secondary}`}
            >
                <div className={`modal-title-box theme-${theme.paragraph}`}>
                    <span
                        className={`theme-${theme.paragraph} modal-title-text`}
                    >
                        {props.title}
                    </span>
                    <span
                        onClick={onCloseClick}
                        className={`theme-${theme.paragraph} modal-close`}
                    >
                        &times;
                    </span>
                </div>
                {props.children}
            </div>
        </div>
    );
}

export function InputModalComponent(props) {
    let [isActivated] = useState(props.isModalActive);
    let [folderName, setFolderName] = useState("");
    const wrapperRef = useRef(null);
    let isOutside = useOutSideAlerter(wrapperRef);
    const theme = useTheme();
    const navigate = useNavigate();

    function onCloseClick(e) {
        e.preventDefault();
        props.setIsModalActive(false);
    }

    let isOpen = isActivated ? "open" : "close";

    useEffect(() => {
        if (isOutside) {
            props.setIsModalActive(false);
        }
    }, [isOutside]);

    useEffect(() => {
        const handleEsc = (event) => {
            if (event.keyCode === 27) {
                props.setIsModalActive(false);
            }
        };

        window.addEventListener("keydown", handleEsc);
        return () => {
            window.removeEventListener("keydown", handleEsc);
        };
    }, []);

    function onSubmit(e) {
        e.preventDefault();
        if (folderName !== "") {
            AddFolderMutation(folderName, (newFolderId) => {
                // console.log("Created new folder ");
            });
        }
        // props.setIsModalActive(false);
        commitLocalUpdate(environment, (store) => {
            const record = store.getRoot().getLinkedRecord("settings");
            record.setValue(false, "isNewFolderView");
            record.setValue(false, "isFullSpanInputModalActivated");
        });

        navigate("/add-source");
    }

    function onChange(e) {
        e.preventDefault();
        setFolderName(e.target.value);
    }

    function onCancelFolderAddClick(e) {
        e.preventDefault();
        commitLocalUpdate(environment, (store) => {
            const record = store.getRoot().getLinkedRecord("settings");
            record.setValue(false, "isNewFolderView");
            record.setValue(false, "isFullSpanInputModalActivated");
        });
    }

    return (
        <div className={``}>
            <form onSubmit={onSubmit}>
                <div className={`input-modal-items`}>
                    <input
                        onChange={onChange}
                        className={`standard-textfield`}
                        placeholder="Enter folder name"
                    />
                    <div>
                        <button
                            onClick={onCancelFolderAddClick}
                            className={`standard-action-button`}
                        >
                            Cancel
                        </button>
                        <input
                            type="submit"
                            className="standard-action-button"
                            value="Create"
                        />
                    </div>
                </div>
            </form>
        </div>
    );
}

export function InputModal(props) {
    let [isActivated] = useState(props.isModalActive);
    let [folderName, setFolderName] = useState("");
    const wrapperRef = useRef(null);
    let isOutside = useOutSideAlerter(wrapperRef);
    const theme = useTheme();
    const navigate = useNavigate();

    function onCloseClick(e) {
        e.preventDefault();
        props.setIsModalActive(false);
    }

    let isOpen = isActivated ? "open" : "close";

    useEffect(() => {
        if (isOutside) {
            props.setIsModalActive(false);
        }
    }, [isOutside]);

    useEffect(() => {
        const handleEsc = (event) => {
            if (event.keyCode === 27) {
                props.setIsModalActive(false);
            }
        };

        window.addEventListener("keydown", handleEsc);
        return () => {
            window.removeEventListener("keydown", handleEsc);
        };
    }, []);

    function onSubmit(e) {
        e.preventDefault();
        if (folderName !== "") {
            AddFolderMutation(folderName, () => {
                // console.log("Created new folder ");
            });
        }
        props.setIsModalActive(false);
        navigate("/add-source");
    }

    function onChange(e) {
        e.preventDefault();
        setFolderName(e.target.value);
    }

    return (
        <div className={`modal-container modal-container-${isOpen}`}>
            <div ref={wrapperRef} className={`modal theme-${theme.secondary}`}>
                <div className={`modal-content`}>
                    <div className={`modal-title-box`}>
                        <span
                            className={`modal-title-text theme-${theme.paragraph}`}
                        >
                            {props.title}
                        </span>
                        <span
                            onClick={onCloseClick}
                            className={`modal-close theme-${theme.paragraph}`}
                        >
                            &times;
                        </span>
                    </div>
                    <div className="modal-contents">
                        <form onSubmit={onSubmit}>
                            <div className={`modal-message-box`}>
                                <input
                                    onChange={onChange}
                                    className={`standard-textfield-long`}
                                />
                                <input
                                    type="submit"
                                    className="standard-action-button"
                                    value="Create"
                                />
                            </div>
                        </form>
                    </div>
                </div>
            </div>
        </div>
    );
}

export function SourceSearchModal(props) {
    let [isActivated] = useState(props.isModalActive);
    let [filterString, setFilterString] = useState("");

    const wrapperRef = useRef(null);
    let isOutside = useOutSideAlerter(wrapperRef);
    const theme = useTheme();

    function onCloseClick(e) {
        e.preventDefault();
        props.setIsModalActive(false);
    }

    let isOpen = isActivated ? "open" : "close";

    useEffect(() => {
        if (isOutside) {
            props.setIsModalActive(false);
        }
    }, [isOutside]);

    useEffect(() => {
        const handleEsc = (event) => {
            if (event.keyCode === 27) {
                props.setIsModalActive(false);
            }
        };

        window.addEventListener("keydown", handleEsc);
        return () => {
            window.removeEventListener("keydown", handleEsc);
        };
    }, []);

    function onSubmit(e) {
        e.preventDefault();
        // updateLocalSetting("sourceString", filterString);
        commitLocalUpdate(environment, (store) => {
            const record = store.getRoot().getLinkedRecord("settings");
            record.setValue("", "categoryId");
            record.setValue(filterString, "sourceString");
        });

        // console.log(filterString);
        props.setIsModalActive(false);
    }

    function onChange(e) {
        e.preventDefault();
        setFilterString(e.target.value);
        // console.log(filterString);
    }

    return (
        <div className={`modal-container modal-container-${isOpen}`}>
            <div ref={wrapperRef} className={`modal theme-${theme.secondary}`}>
                <div className={`modal-content`}>
                    <div className={`modal-title-box`}>
                        <span className={`theme-${theme.paragraph} `}>
                            {props.title}
                        </span>
                        <span
                            onClick={onCloseClick}
                            className={`theme-${theme.paragraph} modal-close`}
                        >
                            &times;
                        </span>
                    </div>
                    <div className="modal-contents">
                        <form onSubmit={onSubmit}>
                            <div className={`modal-message-box`}>
                                <input
                                    placeholder="Search for sources or subjects"
                                    onChange={onChange}
                                    className={`standard-textfield-long search-textfield`}
                                />
                                <input
                                    type="submit"
                                    className="standard-action-button search-button"
                                    value="Search"
                                />
                            </div>
                        </form>
                    </div>
                </div>
            </div>
        </div>
    );
}

export function SourceSearchModalComponent(props) {
    let [isActivated] = useState(props.isModalActive);
    let [filterString, setFilterString] = useState("");

    const wrapperRef = useRef(null);
    let isOutside = useOutSideAlerter(wrapperRef);
    const theme = useTheme();

    let isOpen = isActivated ? "open" : "close";

    useEffect(() => {
        if (isOutside) {
            props.setIsModalActive(false);
        }
    }, [isOutside]);

    function onSubmit(e) {
        e.preventDefault();
        // updateLocalSetting("sourceString", filterString);
        commitLocalUpdate(environment, (store) => {
            const record = store.getRoot().getLinkedRecord("settings");
            record.setValue("", "categoryId");
            record.setValue(filterString, "sourceString");
        });

        commitLocalUpdate(environment, (store) => {
            const record = store.getRoot().getLinkedRecord("settings");
            record.setValue(false, "isFullSpanSourceSearchModalActivated");
        });
    }

    function onCancelClick(e) {
        commitLocalUpdate(environment, (store) => {
            const record = store.getRoot().getLinkedRecord("settings");
            record.setValue(false, "isFullSpanSourceSearchModalActivated");
        });
    }

    function onChange(e) {
        e.preventDefault();
        setFilterString(e.target.value);
        // console.log(filterString);
    }

    return (
        <div className="">
            <form onSubmit={onSubmit}>
                <div className={`source-search-modal-items`}>
                    <input
                        placeholder="Search for sources or subjects"
                        onChange={onChange}
                        className={`standard-textfield`}
                    />
                    <div>
                        <button
                            className={`standard-action-button`}
                            onClick={onCancelClick}
                        >
                            Cancel
                        </button>
                        <input
                            type="submit"
                            className="standard-action-button search-button"
                            value="Search"
                        />
                    </div>
                </div>
            </form>
        </div>
    );
}

export function AddLinkModal(props) {
    let [isActivated] = useState(props.isModalActive);
    let [filterString, setFilterString] = useState("");

    const wrapperRef = useRef(null);
    let isOutside = useOutSideAlerter(wrapperRef);
    const theme = useTheme();

    function onCloseClick(e) {
        e.preventDefault();
        props.setIsModalActive(false);
    }

    let isOpen = isActivated ? "open" : "close";

    useEffect(() => {
        if (isOutside) {
            props.setIsModalActive(false);
        }
    }, [isOutside]);

    useEffect(() => {
        const handleEsc = (event) => {
            if (event.keyCode === 27) {
                props.setIsModalActive(false);
            }
        };

        window.addEventListener("keydown", handleEsc);
        return () => {
            window.removeEventListener("keydown", handleEsc);
        };
    }, []);

    function onSubmit(e) {
        e.preventDefault();
        // commitLocalUpdate(environment, store => {
        //     const record = store.getRoot().getLinkedRecord("settings");
        //     record.setValue("", "categoryId");
        //     record.setValue(filterString, "sourceString");
        // });

        props.setIsModalActive(false);
    }

    function onChange(e) {
        e.preventDefault();
        setFilterString(e.target.value);
        // console.log(filterString);
    }

    return (
        <div className={`modal-container modal-container-${isOpen}`}>
            <div ref={wrapperRef} className={`modal theme-${theme.secondary}`}>
                <div className={`modal-content`}>
                    <div className={`modal-title-box`}>
                        <span className={`theme-${theme.paragraph} `}>
                            {props.title}
                        </span>
                        <span
                            onClick={onCloseClick}
                            className={`theme-${theme.paragraph} modal-close`}
                        >
                            &times;
                        </span>
                    </div>
                    <div className="modal-contents">
                        {/*


                        <form onSubmit={onSubmit}>
                            <div className={`modal-message-box`}>
                                <input
                                    placeholder="RSS/Atom Feed Link"
                                    onChange={onChange}
                                    className={`standard-textfield-long search-textfield`}
                                />
                                <input
                                    type="submit"
                                    className="standard-action-button search-button"
                                    value={props.actionButton}
                                />
                            </div>
                        </form>

            */}
                        <AddFeedBox />
                    </div>
                </div>
            </div>
        </div>
    );
}

export function SearchModalComponent(props) {
    let [isActivated] = useState(props.isModalActive);
    let [filterString, setFilterString] = useState("");
    const navigate = useNavigate();

    const wrapperRef = useRef(null);
    let isOutside = useOutSideAlerter(wrapperRef);
    const theme = useTheme();

    const { is_premium, payment_status } = props.user;

    let isOpen = isActivated ? "open" : "close";

    let isPremiumOrTrial = false;
    if (payment_status === "active" || payment_status === "trialing") {
       isPremiumOrTrial = true;
    } else if (payment_status === "past_due") {
        isPremiumOrTrial = false;
    } else {
        isPremiumOrTrial = false;
    }

    useEffect(() => {
        if (isOutside) {
            props.setIsModalActive(false);
        }
    }, [isOutside]);

    function onCancelClick(e) {
        e.preventDefault();
        updateLocalSetting("isFullSpanSearchModalActivated", false);
    }

    function onSubmit(e) {
        e.preventDefault();

        commitLocalUpdate(environment, (store) => {
            const record = store.getRoot().getLinkedRecord("settings");
            record.setValue(filterString, "filterTerms");
            record.setValue(
                "Search results for " + '"' + filterString + '"' + " from ",
                "metaDescription"
            );
            // record.setValue("", "metaSourceName");
        });

        updateLocalSetting("isFullSpanSearchModalActivated", false);
    }

    function onChange(e) {
        e.preventDefault();
        setFilterString(e.target.value);
        // console.log(filterString);
    }

    function onAdvancedSearchClick(e) {
        e.preventDefault();
        if (isPremiumOrTrial) {
            navigate("/home/analyse");
        } else {
            navigate("/upgrade");
        }
    }

    return (
        <div className={``}>
            <div className={``}>
                <form onSubmit={onSubmit}>
                    <div className={``}>
                        <input
                            placeholder="Enter topic to search"
                            onChange={onChange}
                            className={`standard-textfield search-textfield`}
                        />
                        <div>
                            <button
                                className={`standard-action-button`}
                                onClick={onCancelClick}
                            >
                                {" "}
                                Cancel{" "}
                            </button>
                            <input
                                type="submit"
                                className="standard-action-button search-button"
                                value="Search"
                            />
                        </div>
                    </div>
                </form>
                <div className={`search-modal-advanced-search standard-link }`}>
                    <div></div>
                    {/* <button */}
                    {/*     onClick={onAdvancedSearchClick} */}
                    {/*     className={`theme-${theme.paragraph} link-button`} */}
                    {/* > */}
                    {/*     Advanced Search */}
                    {/* </button> */}
                </div>
            </div>
        </div>
    );
}

export function SearchModal(props) {
    let [isActivated] = useState(props.isModalActive);
    let [filterString, setFilterString] = useState("");
    const navigate = useNavigate();

    const wrapperRef = useRef(null);
    let isOutside = useOutSideAlerter(wrapperRef);
    const theme = useTheme();

    const { is_premium, payment_status } = props.user;

    let isPremiumOrTrial = false;
    if (payment_status === "active" || payment_status === "trialing") {
       isPremiumOrTrial = true;
    } else if (payment_status === "past_due") {
        isPremiumOrTrial = false;
    } else {
        isPremiumOrTrial = false;
    }

    function onCloseClick(e) {
        e.preventDefault();
        props.setIsModalActive(false);
    }

    let isOpen = isActivated ? "open" : "close";

    useEffect(() => {
        if (isOutside) {
            props.setIsModalActive(false);
        }
    }, [isOutside]);

    useEffect(() => {
        const handleEsc = (event) => {
            if (event.keyCode === 27) {
                props.setIsModalActive(false);
            }
        };

        window.addEventListener("keydown", handleEsc);
        return () => {
            window.removeEventListener("keydown", handleEsc);
        };
    }, []);

    function onSubmit(e) {
        e.preventDefault();
        commitLocalUpdate(environment, (store) => {
            const record = store.getRoot().getLinkedRecord("settings");
            record.setValue(filterString, "filterTerms");
            record.setValue(
                "Search results for " + '"' + filterString + '"' + " from ",
                "metaDescription"
            );
            // record.setValue("", "metaSourceName");
        });

        console.log(filterString);
        props.setIsModalActive(false);
    }

    function onChange(e) {
        e.preventDefault();
        setFilterString(e.target.value);
        // console.log(filterString);
    }

    function onAdvancedSearchClick(e) {
        e.preventDefault();
        if (isPremiumOrTrial) {
            navigate("/home/analyse");
        } else {
            navigate("/upgrade");
        }
    }

    return (
        <div className={`modal-container modal-container-${isOpen}`}>
            <div ref={wrapperRef} className={`modal theme-${theme.secondary}`}>
                <div className={`modal-content`}>
                    <div className={`modal-title-box`}>
                        <span
                            className={`title-heading theme-${theme.paragraph}`}
                        >
                            {props.title}
                        </span>
                        <span
                            onClick={onCloseClick}
                            className={`modal-close theme-${theme.paragraph}`}
                        >
                            &times;
                        </span>
                    </div>
                    <div className={`modal-contents theme-${theme.secondary}`}>
                        <form onSubmit={onSubmit}>
                            <div className={`modal-message-box`}>
                                <input
                                    placeholder="Enter topic to search"
                                    onChange={onChange}
                                    className={`standard-textfield-long search-textfield`}
                                />
                                <div>
                                    <input
                                        type="submit"
                                        className="standard-action-button search-button"
                                        value="Search"
                                    />
                                </div>
                            </div>
                        </form>
                        <div
                            className={`search-modal-advanced-search standard-link }`}
                        >
                            <div></div>
                            {/* <button */}
                            {/*     onClick={onAdvancedSearchClick} */}
                            {/*     className={`theme-${theme.paragraph} link-button`} */}
                            {/* > */}
                            {/*     Advanced Search */}
                            {/* </button> */}
                        </div>
                    </div>
                </div>
            </div>
        </div>
    );
}

export function DetailViewModal(props) {
    let [isActivated] = useState(props.isModalActive);
    // let [filterString, setFilterString] = useState("");
    console.log(props.noteId);

    const wrapperRef = useRef(null);
    let isOutside = useOutSideAlerter(wrapperRef);

    function onCloseClick(e) {
        e.preventDefault();
        props.setIsModalActive(false);
    }

    let isOpen = isActivated ? "open" : "close";

    useEffect(() => {
        if (isOutside) {
            props.setIsModalActive(false);
        }
    }, [isOutside]);

    useEffect(() => {
        const handleEsc = (event) => {
            if (event.keyCode === 27) {
                props.setIsModalActive(false);
            }
        };

        window.addEventListener("keydown", handleEsc);
        return () => {
            window.removeEventListener("keydown", handleEsc);
        };
    }, []);

    return (
        <div
            className={`detailview-modal-container modal-container modal-container-${isOpen}`}
        >
            <div ref={wrapperRef} className={`detailview-modal`}>
                <div className={`modal-content`}>
                    <div className={`modal-title-box`}>
                        <div>
                            <span className="title-text">{props.title}</span>
                            <span
                                onClick={onCloseClick}
                                className={`modal-close`}
                            >
                                &times;
                            </span>
                        </div>
                    </div>

                    <div className="detail-posts-container">
                        <div
                            style={{
                                paddingRight: "30rem",
                                paddingLeft: "30rem",
                                lineHeight: "1.5",
                                textAlign: "center",
                            }}
                        >
                            <h1> {props.postTitle}</h1>
                        </div>
                        <div>
                            <img
                                width={600}
                                src={props.postImageURL}
                                alt={""}
                            />
                        </div>
                        <div
                            style={{
                                paddingTop: "4rem",
                                paddingRight: "30rem",
                                paddingLeft: "30rem",
                                lineHeight: "1.5",
                            }}
                        >
                            {" "}
                            {props.postBody}{" "}
                        </div>
                        <div>
                            <a
                                target="_blank"
                                rel="noopener noreferrer"
                                href={props.postLink}
                            >
                                Know More
                            </a>{" "}
                        </div>
                    </div>
                </div>
            </div>
        </div>
    );
}

export function NoteModalComponent(props) {
    let [isActivated, setIsActivated] = useState(props.isModalActive);
    const wrapperRef = useRef(null);
    let isOutside = useOutSideAlerter(wrapperRef);
    const theme = useTheme();

    function onCloseClick(e) {
        e.preventDefault();
        props.setIsModalActive(false);
    }

    let isOpen = isActivated ? "open" : "close";

    useEffect(() => {
        if (isOutside) {
            props.setIsModalActive(false);
        }
    }, [isOutside]);

    useEffect(() => {
        const handleEsc = (event) => {
            if (event.keyCode === 27) {
                props.setIsModalActive(false);
            }
        };

        window.addEventListener("keydown", handleEsc);
        return () => {
            window.removeEventListener("keydown", handleEsc);
        };
    }, []);

    return (
        <div className="rich-text-container$">
            <RichTextEditor
                postId={props.postId}
                rowContent={props.rowContent}
                jsonContent={props.jsonContent}
                noteId={props.noteId}
                isEdit={props.isEdit}
                isDetailView={props.isDetailView}
                setIsActivated={setIsActivated}
            />
        </div>
    );
}

export function NoteModal(props) {
    let [isActivated, setIsActivated] = useState(props.isModalActive);
    const wrapperRef = useRef(null);
    let isOutside = useOutSideAlerter(wrapperRef);
    const theme = useTheme();

    function onCloseClick(e) {
        e.preventDefault();
        props.setIsModalActive(false);
    }

    let isOpen = isActivated ? "open" : "close";

    useEffect(() => {
        if (isOutside) {
            props.setIsModalActive(false);
        }
    }, [isOutside]);

    useEffect(() => {
        const handleEsc = (event) => {
            if (event.keyCode === 27) {
                props.setIsModalActive(false);
            }
        };

        window.addEventListener("keydown", handleEsc);
        return () => {
            window.removeEventListener("keydown", handleEsc);
        };
    }, []);

    return (
        <div
            className={`note-modal-container modal-container modal-container-${isOpen}`}
        >
            <div ref={wrapperRef} className={`note-modal`}>
                <div className={`modal-content`}>
                    <div className={`modal-title-box`}>
                        <span className="modal-title-text">{props.title}</span>
                        <span
                            onClick={onCloseClick}
                            className={`modal-close theme-${theme.paragraph}`}
                        >
                            &times;
                        </span>
                    </div>

                    <div className="rich-text-container">
                        <RichTextEditor
                            postId={props.postId}
                            rowContent={props.rowContent}
                            jsonContent={props.jsonContent}
                            noteId={props.noteId}
                            isEdit={props.isEdit}
                            isDetailView={props.isDetailView}
                            setIsActivated={setIsActivated}
                        />
                    </div>
                </div>
            </div>
        </div>
    );
}

export function ShareModal(props) {
    let [isActivated] = useState(props.isModalActive);
    const { is_premium, payment_status } = props.user;

    const wrapperRef = useRef(null);
    let isOutside = useOutSideAlerter(wrapperRef);
    const theme = useTheme();
    const navigate = useNavigate();

    let enabled = false;
    if (payment_status === "active" || payment_status === "trialing") {
       enabled = true;
    } else if (payment_status === "past_due") {
        enabled = false;
    } else {
        enabled = false;
    }

    function onCloseClick(e) {
        e.preventDefault();
        props.setIsModalActive(false);
    }

    let isOpen = isActivated ? "open" : "close";

    useEffect(() => {
        if (isOutside) {
            props.setIsModalActive(false);
        }
    }, [isOutside]);

    useEffect(() => {
        const handleEsc = (event) => {
            if (event.keyCode === 27) {
                props.setIsModalActive(false);
            }
        };

        window.addEventListener("keydown", handleEsc);
        return () => {
            window.removeEventListener("keydown", handleEsc);
        };
    }, []);

    function onPremiumShareClick(e) {
        if (payment_status === "active" || payment_status === "trialing") {
        } else if (payment_status === "past_due") {
            navigate("/complete-payment");
        } else {
            navigate("/upgrade");
        }
    }

    return (
        <div className={`modal-container modal-container-${isOpen}`}>
            <div
                ref={wrapperRef}
                className={`modal theme-${theme.secondary} share-modal`}
            >
                <div className={`modal-content`}>
                    <div className={`modal-title-box`}>
                        <span className={`theme-${theme.paragraph}`}>
                            {props.title}
                        </span>
                        <span
                            onClick={onCloseClick}
                            className={`modal-close theme-${theme.paragraph}`}
                        >
                            &times;
                        </span>
                    </div>

                    <div className="share-icons-container">
                        <EmailShareButton
                            subject={props.postTitle}
                            url={props.postLink}
                            body={`${props.postBody} (Aggregated via https://thefeedgram.com) `}
                        >
                            <EmailIcon size={64} round={true} />
                        </EmailShareButton>
                        <FacebookShareButton url={props.postLink}>
                            {" "}
                            <FacebookIcon size={64} round={true} />{" "}
                        </FacebookShareButton>
                        <TwitterShareButton
                            url={
                                props.postLink +
                                "  (Aggregated via https://thefeedgram.com - the intelligent news reader)"
                            }
                        >
                            {" "}
                            <TwitterIcon size={64} round={true} />{" "}
                        </TwitterShareButton>
                        <LinkedinShareButton
                            disabled={!enabled}
                            url={props.postLink}
                        >
                            <LinkedinIcon
                                onClick={onPremiumShareClick}
                                size={64}
                                round={true}
                            />
                        </LinkedinShareButton>
                        <InstapaperShareButton
                            disabled={!enabled}
                            url={props.postLink}
                        >
                            <InstapaperIcon
                                onClick={onPremiumShareClick}
                                round={true}
                                size={64}
                            />
                        </InstapaperShareButton>
                        <PocketShareButton
                            disabled={!enabled}
                            url={props.postLink}
                        >
                            <PocketIcon
                                onClick={onPremiumShareClick}
                                size={64}
                                round={true}
                            />
                        </PocketShareButton>
                        <RedditShareButton
                            title={props.postTitle}
                            url={props.postLink}
                        >
                            <RedditIcon size={64} round={true} />
                        </RedditShareButton>
                        <TumblrShareButton
                            url={props.postLink}
                            title={props.postTitle}
                            caption={props.postBody}
                        >
                            <TumblrIcon size={64} round={true} />
                        </TumblrShareButton>

                        <LivejournalShareButton
                            url={props.postLink}
                            title={props.postTitle}
                            description={props.postBody}
                        >
                            <LivejournalIcon size={64} round={true} />
                        </LivejournalShareButton>

                        <TelegramShareButton
                            url={props.postLink}
                            title={props.postTitle}
                        >
                            <TelegramIcon size={64} round={true} />
                        </TelegramShareButton>

                        <VKShareButton
                            url={props.postLink}
                            title={props.postTitle}
                        >
                            <VKIcon size={64} round={true} />
                        </VKShareButton>

                        <WhatsappShareButton
                            url={
                                props.postLink +
                                "  (Aggregated via https://thefeedgram.com)"
                            }
                            title={props.postTitle}
                        >
                            <WhatsappIcon size={64} round={true} />
                        </WhatsappShareButton>
                        <WorkplaceShareButton
                            url={props.postLink}
                            quote="Aggregated via http://thefeedgram.com"
                            hashtag="#JustMakesSense"
                            disabled={!enabled}
                        >
                            <WorkplaceIcon
                                onClick={onPremiumShareClick}
                                size={64}
                                round={true}
                            />
                        </WorkplaceShareButton>
                        <ViberShareButton
                            url={props.postLink}
                            title={props.postTitle}
                        >
                            <ViberIcon size={64} round={true} />
                        </ViberShareButton>
                        <HatenaShareButton
                            url={props.postLink}
                            title={props.postTitle}
                        >
                            <HatenaIcon size={64} round={true} />
                        </HatenaShareButton>

                        <OKShareButton
                            url={props.postLink}
                            title={props.postTitle}
                            description={props.postBody}
                        >
                            <OKIcon size={64} round={true} />
                        </OKShareButton>

                        <MailruShareButton
                            url={props.postLink}
                            title={props.postTitle}
                            description={props.postBody}
                        >
                            <MailruIcon size={64} round={true} />
                        </MailruShareButton>
                    </div>
                </div>
            </div>
        </div>
    );
}

export function ShareModalComponent(props) {
    // let [isActivated] = useState(props.isModalActive);

    const wrapperRef = useRef(null);
    let isOutside = useOutSideAlerter(wrapperRef);
    const { is_premium, payment_status } = props.user;
    console.log(is_premium);
    const theme = useTheme();
    const navigate = useNavigate();

    let enabled = false;
    if (payment_status === "active" || payment_status === "trialing") {
       enabled = true;
    } else if (payment_status === "past_due") {
        enabled = false;
    } else {
        enabled = true;
    }

    function onPremiumShareClick(e) {
        if (!enabled) {
            navigate("/upgrade");
        }
    }

    return (
        <div className={``}>
            <div className="share-icons-container">
                <EmailShareButton
                    subject={props.postTitle}
                    url={props.postLink}
                    body={`${props.postBody} (Aggregated via www.thefeedgram.com) `}
                >
                    <EmailIcon size={64} round={true} />
                </EmailShareButton>
                <FacebookShareButton url={props.postLink}>
                    {" "}
                    <FacebookIcon size={64} round={true} />{" "}
                </FacebookShareButton>
                <TwitterShareButton url={props.postLink}>
                    {" "}
                    <TwitterIcon size={64} round={true} />{" "}
                </TwitterShareButton>
                <LinkedinShareButton
                    disabled={!enabled}
                    url={props.postLink}
                >
                    <LinkedinIcon
                        onClick={onPremiumShareClick}
                        size={64}
                        round={true}
                    />
                </LinkedinShareButton>
                <InstapaperShareButton
                    disabled={!enabled}
                    url={props.postLink}
                >
                    <InstapaperIcon
                        onClick={onPremiumShareClick}
                        round={true}
                        size={64}
                    />
                </InstapaperShareButton>
                <PocketShareButton disabled={!enabled} url={props.postLink}>
                    <PocketIcon
                        onClick={onPremiumShareClick}
                        size={64}
                        round={true}
                    />
                </PocketShareButton>
                <RedditShareButton title={props.postTitle} url={props.postLink}>
                    <RedditIcon size={64} round={true} />
                </RedditShareButton>
                <TumblrShareButton
                    url={props.postLink}
                    title={props.postTitle}
                    caption={props.postBody}
                >
                    <TumblrIcon size={64} round={true} />
                </TumblrShareButton>

                <LivejournalShareButton
                    url={props.postLink}
                    title={props.postTitle}
                    description={props.postBody}
                >
                    <LivejournalIcon size={64} round={true} />
                </LivejournalShareButton>

                <TelegramShareButton
                    url={props.postLink}
                    title={props.postTitle}
                >
                    <TelegramIcon size={64} round={true} />
                </TelegramShareButton>

                <VKShareButton url={props.postLink} title={props.postTitle}>
                    <VKIcon size={64} round={true} />
                </VKShareButton>

                <WhatsappShareButton
                    url={
                        props.postLink +
                        "  (Aggregated via https://thefeedgram.com)"
                    }
                    title={props.postTitle}
                >
                    <WhatsappIcon size={64} round={true} />
                </WhatsappShareButton>
                <WorkplaceShareButton
                    url={props.postLink}
                    quote="Aggregated via http://thefeedgram.com"
                    hashtag="#JustMakesSense"
                    disabled={!enabled}
                >
                    <WorkplaceIcon size={64} round={true} />
                </WorkplaceShareButton>
                <ViberShareButton url={props.postLink} title={props.postTitle}>
                    <ViberIcon size={64} round={true} />
                </ViberShareButton>
                <HatenaShareButton url={props.postLink} title={props.postTitle}>
                    <HatenaIcon size={64} round={true} />
                </HatenaShareButton>

                <OKShareButton
                    url={props.postLink}
                    title={props.postTitle}
                    description={props.postBody}
                >
                    <OKIcon size={64} round={true} />
                </OKShareButton>

                <MailruShareButton
                    url={props.postLink}
                    title={props.postTitle}
                    description={props.postBody}
                >
                    <MailruIcon size={64} round={true} />
                </MailruShareButton>
            </div>
        </div>
    );
}
